import * as React from "react";
import {connect} from "react-redux";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {Action, Dispatch} from "redux";
import {AppNotificationMessage} from "../../domain/model/app_notification_message";
import {Client} from "../../domain/model/client";
import {Company} from "../../domain/model/company";
import {User} from "../../domain/model/user";
import {createAppNotificationMessageActionCreator} from "../action/app_notification_message_action";
import {createAuthActionCreator} from "../action/auth_action";
import {AuthStateType} from "../auth_state_type";
import LayoutComponent from "../component/layout/layout";
import {
    createAppNotificationMessageDispatcher,
    IAppNotificationMessageDispatcher,
} from "../dispatcher/app_notification_message_dispatcher";
import {createAuthDispatcher, IAuthDispatcher,} from "../dispatcher/auth_dispatcher";
import {HiddenAppNotificationRequest} from "../request/app_notification_message_request";
import {AppNotificationMessageState} from "../store/app_notification_message_state";
import {AppState} from "../store/app_state";
import {AuthState} from "../store/auth_state";

interface IProps extends RouteComponentProps<{}> {
    state: AuthState;
    notificationState: AppNotificationMessageState;
    dispatcher: IAuthDispatcher;
    notificationDispatcher: IAppNotificationMessageDispatcher;
}

interface IState {
    timer?: number;
    isMenuOpen: boolean;
}

const customerMessageRoomPattern = new RegExp("^/customer/message.*$");
const clientMessageRoomPattern = new RegExp("^/client/message.*$");
const customerTutorialPattern = new RegExp("^/customer/tutorial.*$");
const customerSignUpPattern = new RegExp("^/customer/_create.*$");
const customerDashboardPattern = "/customer";

export class Layout extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            timer: undefined,
            // left: false,
            // anchorEl: null,
            isMenuOpen: false,
        };
    }

    public componentDidMount() {
        this.sendPageChange(
            this.props.location.pathname,
            this.props.location.search
        );
        // observer 登録
        this.props.dispatcher.onAuthListener({});
    }

    public componentWillUnmount(): void {
        // observer 解除
        this.props.dispatcher.offAuthListener({});
    }

    public componentDidUpdate(prevProps: IProps) {
        const authState: AuthStateType = this.props.state.authState;

        // ログイン状態が変わった場合のみ実行
        if (authState !== prevProps.state.authState) {
            // ログイン状態での場合分け
            switch (authState) {
                // 非ログイン時
                case AuthStateType.UNKNOWN: {
                    // タイマーがセットしてあったらタイマーをクリア
                    if (this.state.timer) {
                        clearInterval(this.state.timer);
                        this.setState({
                            timer: undefined,
                        });
                    }
                    break;
                }
                // ログイン時
                case AuthStateType.LOGIN_USER: {
                    // タイマーがセットしてなかったらタイマーをセット
                    if (!this.state.timer) {
                        const timer: number = window.setInterval(
                            this.props.dispatcher.getMe,
                            30000
                        );
                        this.setState({
                            timer,
                        });
                    }

                    this.props.dispatcher.getMe();
                    break;
                }
            }
        }

        // ページ遷移があった場合のgtag送信
        if (
            this.props.location.pathname !== prevProps.location.pathname ||
            this.props.location.search !== prevProps.location.search
        ) {
            this.sendPageChange(
                this.props.location.pathname,
                this.props.location.search
            );
        }
    }

    public render(): JSX.Element {
        const {notificationState} = this.props;
        const {isMenuOpen} = this.state;

        const isMessageRoom =
            customerMessageRoomPattern.test(this.props.location.pathname) ||
            clientMessageRoomPattern.test(this.props.location.pathname);
        const isTutorial = customerTutorialPattern.test(
            this.props.location.pathname
        );
        const isDashboard =
            customerDashboardPattern === this.props.location.pathname;
        const isCustomerCreate = customerSignUpPattern.test(
            this.props.location.pathname
        );

        const user: User | null = this.props.state.user;
        const company: Company | null = this.props.state.company;
        const children: React.ReactNode = this.props.children;

        const notificationMessages: AppNotificationMessage[] =
            notificationState.appNotificationMessages;

        return (
            <LayoutComponent
                user={user}
                company={company}
                isMenuOpen={isMenuOpen}
                handleOpenMenu={this.handleOpenMenu}
                handleCloseMenu={this.handleCloseMenu}
                isMessageRoom={isMessageRoom}
                isTutorial={isTutorial}
                isDashboard={isDashboard}
                isCustomerCreate={isCustomerCreate}
                handleOnCloseNotification={this.handleOnCloseNotification}
                notificationMessages={notificationMessages}
                children={children}
                handleSearchForCustomer={this.handleSearchForCustomer}
                handleSearchForClient={this.handleSearchForClient}
            />
        );
    }

    private handleSearchForCustomer = (values: any): void => {
        const query: string = values.q ? values.q : "";
        const {history} = this.props;
        history.push(`/customer/projects?q=${query}&p=1`);
    };

    private handleSearchForClient = (values: any): void => {
        const query: string = values.q ? values.q : "";
        const {history} = this.props;
        history.push(`/client/scout/customers?q=${query}&p=1`);
    };

    private handleCloseMenu = (event: React.MouseEvent<HTMLElement>): void => {
        this.setState({
            isMenuOpen: false,
        });
    };

    private handleOpenMenu = (event: React.MouseEvent<HTMLElement>): void => {
        this.setState({
            isMenuOpen: true,
        });
    };

    private handleOnCloseNotification =
        (id: string) =>
            (event: any): void => {
                const item: HiddenAppNotificationRequest =
                    new HiddenAppNotificationRequest();
                item.id = id;
                this.props.notificationDispatcher.hidden(item);
            };

    // url直接叩かれたりページ遷移があった場合GAへタグを送る
    private sendPageChange = (pathname: string, search: string = "") => {
        const page = pathname + search;
        const client: Client | null = this.props.state.user
            ? this.props.state.user.client
            : null;
        const company: Company | null = this.props.state.company;

        if (client && company) {
            const event_name = "client_page_view";
            const event_params = {
                page,
                client_id: client.id,
                client_name: client!.name,
                client_email: this.props.state.user!.email,
                company_id: company!.id,
                company_name: company!.name,
            };

            if (window.gtag) {

                window.gtag("event", event_name, event_params);
            }
        }
    };
}

const mapStateToProps = (state: AppState) => {
    return {
        state: state.authReducer,
        notificationState: state.appNotificationMessageReducer,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {
        dispatcher: createAuthDispatcher(dispatch, createAuthActionCreator()),
        notificationDispatcher: createAppNotificationMessageDispatcher(
            dispatch,
            createAppNotificationMessageActionCreator()
        ),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));



// WEBPACK FOOTER //
// ./src/presentation/container/layout_container.tsx